type Props = {
    archived: boolean
    unarchiving: boolean
    onUnarchive: () => void
    onRequestArchive: () => void
}

/**
 * Archive or unarchive the classifier. There's deliberately no delete: classification
 * results reference the classifier, and removing it would orphan them.
 */
export default function ClassifierArchiveCard({
    archived,
    unarchiving,
    onUnarchive,
    onRequestArchive
}: Props) {
    if (archived) {
        return (
            <div className="rounded-lg border border-ink-200 bg-white p-4">
                <div className="flex items-center justify-between">
                    <div>
                        <h2 className="text-sm font-semibold text-ink-900">Unarchive classifier</h2>
                        <p className="mt-0.5 text-xs text-ink-500">
                            This classifier is archived and applied to no profiles. Unarchiving
                            makes it usable again — you&rsquo;ll need to re-apply it to profiles.
                        </p>
                    </div>
                    <button
                        type="button"
                        onClick={onUnarchive}
                        disabled={unarchiving}
                        className="rounded-lg border border-ink-200 bg-white px-3 py-2 text-sm font-semibold text-ink-700 hover:bg-ink-50 disabled:opacity-50"
                    >
                        {unarchiving ? 'Unarchiving…' : 'Unarchive'}
                    </button>
                </div>
            </div>
        )
    }

    return (
        <div className="rounded-lg border border-severe/30 bg-white p-4">
            <div className="flex items-center justify-between">
                <div>
                    <h2 className="text-sm font-semibold text-ink-900">Archive classifier</h2>
                    <p className="mt-0.5 text-xs text-ink-500">
                        Removes it from every profile and takes it out of use. Reversible, but
                        deployments aren&rsquo;t restored on unarchive.
                    </p>
                </div>
                <button
                    type="button"
                    onClick={onRequestArchive}
                    className="rounded-lg border border-severe/40 bg-white px-3 py-2 text-sm font-semibold text-severe hover:bg-severe/10"
                >
                    Archive
                </button>
            </div>
        </div>
    )
}
